import { highlightText } from '@weezevent/nacre';
import React from 'react';
import { StatusEvent } from './eventsPicker';

export function eventListItemsRenderer(option, words = []) {
    // renders an event as a select3 option, and highlights the event name
    return (
        <div className={'events-picker-options'}>
            <div>
                <div className={'events-picker-options-name'}>{highlightText(option.event.name, words)}</div>
                <div className={'events-picker-options-date'}>
                    {new Date(option.event.start_date).toLocaleDateString([], {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        timeZone: option.event.timezone
                    })}
                    {' - '}
                    <span>{highlightText(String(option.event.id), words)}</span>
                </div>
            </div>
            <div>
                <StatusEvent status={option.event.publication_status} />
            </div>
        </div>
    );
}
